module.exports = __webpack_public_path__ + "img/drycow.1b7d1ff1.png";